import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import DispatchContext from '../DispatchContext';
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";

// Constanta pentru mediu
const IS_SANDBOX = false;

// Client ID-ul PayPal în funcție de mediu
const PAYPAL_CLIENT_ID = IS_SANDBOX 
    ? "ASATxUiQ3DPP_HSc_6ViCT5mXFHhKQ_q-BbkU_dt0ltf3tQmUcecDMK-BERYWqlDyocPT3FnFznggH5L" 
    : "AfmD3LkdLeGfP4dGjeeh21r-5rDiPi89npqVJcfQDbHkKC_vU9bC2gGUhQFDVsWP3D4eOw-IZ0O05eiY";

// Planurile de subscripție în funcție de mediu
const PLAN_IDS = IS_SANDBOX
    ? {
        basic: "P-5FV51357UR263653VNBD63PQ", // ID-ul planului basic din sandbox
        premium: "P-86R63192TA1398015NBD633Y" // ID-ul planului premium din sandbox
      }
    : {
        basic: "P-9V750021720853804NBDPP2Q", // ID-ul planului basic din live
        premium: "P-66A54310N4824382WNBDPQ6I" // ID-ul planului premium din live
      };

const API_BASE = "https://backend.alephmedia.ro/api";

function Register() {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [c_password, setCPassword] = useState('');
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [registered, setRegistered] = useState(false);
    const [selected, setSelected] = useState('basic'); // 'basic' sau 'premium'
    const dispatch = useContext(DispatchContext);
    const navigate = useNavigate();

    const handleNext = (event) => {
        event.preventDefault();
        setError(null);

        if (!name || !email || !password || !c_password) {
            setError('Toate câmpurile sunt obligatorii');
            return;
        }
        if (password !== c_password) {
            setError('Parolele nu se potrivesc');
            return;
        }
        if (!/\S+@\S+\.\S+/.test(email)) {
            setError('Email invalid');
            return;
        }
        setRegistered(true);
    };

    if (registered) {
        return (
            <div className="auth-wrapper">
                <div className="auth-container">
                    <div className="auth-logo">
                        <a href="/">
                            <img src="/assets/img/logo-aleph-rosu.png" alt="Aleph" />
                        </a>
                    </div>
                    <h2 className="auth-title">Alegeți abonamentul</h2>
                    <div className="subscription-options vertical">
                        <div
                            className={`subscription-option${selected === 'basic' ? ' selected' : ''}`}
                            onClick={() => setSelected('basic')}
                            tabIndex={0}
                            role="button"
                            aria-pressed={selected === 'basic'}
                        >
                            <h3>Abonament Basic</h3>
                            <p className="price">1€ / lună</p>
                            <ul>
                                <li>Acces la știrile de bază</li>
                                <li>Notificări importante</li>
                                <li>Conținut exclusiv limitat</li>
                            </ul>
                            {selected === 'basic' && <div className="checkmark">✔</div>}
                        </div>
                        <div
                            className={`subscription-option${selected === 'premium' ? ' selected' : ''}`}
                            onClick={() => setSelected('premium')}
                            tabIndex={0}
                            role="button"
                            aria-pressed={selected === 'premium'}
                        >
                            <h3>Abonament Premium</h3>
                            <p className="price">2€ / lună</p>
                            <ul>
                                <li>Acces nelimitat la tot conținutul</li>
                                <li>Conținut exclusiv premium</li>
                                <li>Suport prioritar</li>
                            </ul>
                            {selected === 'premium' && <div className="checkmark">✔</div>}
                        </div>
                    </div>
                    <div className="payment-buttons-container">
                        <PayPalScriptProvider options={{ "client-id": PAYPAL_CLIENT_ID, vault: true, locale: "ro_RO", intent: "subscription" }}>
                            <PayPalButtons
                                style={{ layout: "vertical" }}
                                createSubscription={(data, actions) => {
                                    return actions.subscription.create({
                                        plan_id: PLAN_IDS[selected]
                                    });
                                }}
                                onApprove={async (data, actions) => {
                                    // Salvează datele în localStorage, inclusiv nivelul subscripției
                                    localStorage.setItem('subscriptionLevel', selected);
                                    localStorage.setItem('subscriptionId', data.subscriptionID);
                                    
                                    // Trimite la backend pentru a salva subscripția la user
                                    try {
                                        const response = await fetch(`${API_BASE}/payment/paypal/save-subscription`, {
                                            method: 'POST',
                                            headers: { 'Content-Type': 'application/json' },
                                            body: JSON.stringify({
                                                email,
                                                name,
                                                password,
                                                subscription_id: data.subscriptionID,
                                                level: selected
                                            })
                                        });
                                        
                                        const result = await response.json();
                                        if (result.success) {
                                            // Salvăm toate datele relevante în localStorage
                                            localStorage.setItem('authToken', result.data.token);
                                            localStorage.setItem('userData', JSON.stringify({
                                                name: result.data.name,
                                                email: result.data.email,
                                                subscription_type: result.data.subscription_type,
                                                subscription_status: result.data.subscription_status,
                                                subscription_expires_at: result.data.subscription_expires_at
                                            }));
                                            dispatch({ type: "userLoggedIn", payload: {
                                                name: result.data.name,
                                                email: result.data.email,
                                                subscription_type: result.data.subscription_type,
                                                subscription_status: result.data.subscription_status,
                                                subscription_expires_at: result.data.subscription_expires_at
                                            }});
                                            dispatch({
                                                type: "newEvent",
                                                value: {
                                                    header: "Abonament activat",
                                                    message: "Plata recurentă a fost activată cu succes!",
                                                    link: "/"
                                                }
                                            });
                                            navigate('/');
                                        } else {
                                            throw new Error(result.message || 'Eroare la salvarea subscripției');
                                        }
                                    } catch (e) {
                                        console.error('Eroare la salvarea subscripției:', e);
                                        setError('Eroare la salvarea subscripției. Vă rugăm să contactați suportul.');
                                    }
                                }}
                                onError={(err) => {
                                    setError('Eroare la procesarea plății: ' + (err.message || '')); 
                                    setLoading(false);
                                }}
                            />
                        </PayPalScriptProvider>
                    </div>
                    {error && <p className="error">{error}</p>}
                </div>
            </div>
        );
    }

    return (
        <div className="auth-wrapper">
            <div className="auth-container">
                <div className="auth-logo">
                    <a href="/">
                        <img src="/assets/img/logo-aleph-rosu.png" alt="Aleph" />
                    </a>
                </div>
                <h1 className="auth-title">Înregistrare</h1>
                <form onSubmit={handleNext}>
                    <input
                        type="text"
                        placeholder="Nume complet"
                        value={name}
                        onChange={e => setName(e.target.value)}
                        required
                    />
                    <input
                        type="email"
                        placeholder="Email"
                        value={email}
                        onChange={e => setEmail(e.target.value)}
                        required
                    />
                    <input
                        type="password"
                        placeholder="Parolă"
                        value={password}
                        onChange={e => setPassword(e.target.value)}
                        required
                    />
                    <input
                        type="password"
                        placeholder="Confirmă parola"
                        value={c_password}
                        onChange={e => setCPassword(e.target.value)}
                        required
                    />
                    <button type="submit" className="form-submit">Continuă</button>
                    {error && <p className="error">{error}</p>}
                </form>
            </div>
        </div>
    );
}

export default Register; 